/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Emptystate3Inputs */

const en_coinvestments_dataroom_emptystate3 = /** @type {(inputs: Coinvestments_Dataroom_Emptystate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No files in this data room yet`)
};

/**
* | output |
* | --- |
* | "No files in this data room yet" |
*
* @param {Coinvestments_Dataroom_Emptystate3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_emptystate3 = /** @type {((inputs?: Coinvestments_Dataroom_Emptystate3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Emptystate3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_emptystate3(inputs)
});
export { coinvestments_dataroom_emptystate3 as "coInvestments_dataRoom_emptyState" }